import { mapEmployeeToUserCreditor } from "../utils/vendor.utils"
import { useEmployeeById, useEmployees, useLoggedInEmployee } from "./employee.hooks"

/*
 * CREDITOR-HOOKS
 */

export const useUserCreditorById = (creditorId: string | undefined) => {
    const employee = useEmployeeById(creditorId)

    return employee ? mapEmployeeToUserCreditor(employee) : undefined
}

export const useUserCreditors = (canSeeEveryEmployee: boolean) => {
    const employees = useEmployees({ excludeDeleted: true })
    const currentEmployee = useLoggedInEmployee()

    const userCreditors = employees.map(mapEmployeeToUserCreditor)
    return canSeeEveryEmployee ? userCreditors : [mapEmployeeToUserCreditor(currentEmployee)]
}
